import {Grid, Typography, ButtonBase} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import portada_Home from "../../../Recursos/porta1.png";
const Portada_Home = () => {
    const {sCell, sTab} = useResponsive();
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                py: sCell ? 0 : sTab ? 18 : 20,
                pt:sCell?12:20,
                background: '#F5F6F7',
                position: 'relative',
                overflow: 'hidden',
                minHeight: sCell ? 'auto' : '480px',
            }}
        >
            {!sCell && (
                <Grid
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: sTab ? '100%' : '55%',
                        zIndex: 0,
                    }}
                >
                    <Grid
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            background: 'linear-gradient(to right, #F5F6F7 0%, #F5F6F7 20%, rgba(245,246,247,0.5) 50%, rgba(245,246,247,0) 100%)',
                            zIndex: 1,
                        }}
                    />
                    <img
                        loading="eager"
                        src={portada_Home}
                        alt="mantenimiento locativo, adecuaciones locativas y SST en obras en Cali"
                        style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'left center',
                        display: 'block',
                    }}
                        />
                </Grid>
            )}
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 10}}
                sx={{maxWidth: '1400px', px: 3, position: 'relative', zIndex: 2}}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 9, md: 9}}
                >
                    <Grid
                        container
                        justifyContent={{xs: 'center', md: 'flex-start'}}
                        alignItems={{xs: 'center', md: 'flex-start'}}
                        size={{xs: 12, sm: 12, md: 12}}
                    >
                        <Typography
                            component="h1"
                            variant="h1"
                            sx={{
                                pr: sCell ? 0 : 4,
                                textAlign: sCell ? 'center' : 'left',
                            }}
                        >
                            Evaluación técnica en viviendas y edificaciones después de un terremoto
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >
                        <Typography
                            component="p"
                            variant={'body1'}
                            sx={{
                                pr: sCell ? 0 : 4,
                                pt: 4,
                                textAlign: sCell ? 'center' : 'left',
                                maxWidth:600,
                            }}
                        >
                            Evaluamos, orientamos y te ayudamos a tomar desiciones informadas para proteger lo mas importante: Tu hogar

                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent={{xs: 'center', md: 'flex-start'}}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{pt: 4}}
                    >
                        <RouterLink
                            to={`/contacto/`}
                            variant={'span'}
                            style={{textDecoration: "none"}}
                        >
                            <ButtonBase
                                sx={{
                                    backgroundColor: "#223B59",
                                    color: "#fff",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    textTransform: "none",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 0,
                                    "&:hover": {backgroundColor: "#1A2F47"},
                                }}
                            >
                                Agendar inspección técnica
                            </ButtonBase>
                        </RouterLink>
                    </Grid>
                </Grid>
            </Grid>
            {sCell && (
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{xs: 12}}
                    sx={{pt: 0, position: 'relative'}}
                >
                    <Grid
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            background: 'linear-gradient(to bottom, #F5F6F7 0%, rgba(245,246,247,0.4) 30%, rgba(245,246,247,0.5) 100%)',
                            zIndex: 1,
                        }}
                    />
                    <img
                        src={portada_Home}
                        alt="mantenimiento locativo, adecuaciones locativas y SST en obras en Cali"
                        loading={'eager'}
                        style={{
                            width: '100%',
                            height: '280px',
                            objectFit: 'cover',
                            objectPosition: 'left center',
                            display: 'block',
                        }}
                    />
                </Grid>
            )}
        </Grid>
    );
};
export default Portada_Home;